import script from "./esRelationship.vue?vue&type=script&setup=true&lang=ts"
export * from "./esRelationship.vue?vue&type=script&setup=true&lang=ts"

import "./esRelationship.vue?vue&type=style&index=0&id=5ee93ef6&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee93ef6"]])

export default __exports__